<!-- 
<ngx-loading [show]="pageLoading" ></ngx-loading> -->
<app-header (toggleSidebarForMe)="sideBarToggler($event)"  (logoutForMe)="logout($event)"></app-header>
<mat-drawer-container>
    <mat-drawer mode="side" [opened]="sideBarOpen">
        <app-sidebar></app-sidebar>
    </mat-drawer>
    <mat-drawer-content>
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>
<app-footer></app-footer>
